// Formas de pagamento do fechamento de caixa — cada forma em linha própria, sem agrupar.
// Mesmas chaves gravadas nas vendas (payments[].method / payment_method).
export const CLOSING_METHODS = [
  { key: 'dinheiro', label: 'Dinheiro', icon: '💵', always: true },
  { key: 'pix_maquininha', label: 'PIX Maquininha', icon: '📲', always: true },
  { key: 'debito', label: 'Cartão de Débito', icon: '💳', always: true },
  { key: 'credito', label: 'Cartão de Crédito', icon: '💳', always: true },
  { key: 'voucher', label: 'Voucher', icon: '🎟️', always: true },
  { key: 'pix', label: 'PIX (conta da loja)', icon: '📱' },
  { key: 'cheque', label: 'Cheque', icon: '🧾' },
  { key: 'cartao', label: 'Cartão (legado)', icon: '💳' },
];

export const A_PRAZO = { key: 'a_prazo', label: 'Venda a Prazo (Crediário)', icon: '🕐' };

export const closingLabel = (k) =>
  k === 'a_prazo' ? A_PRAZO.label : ((CLOSING_METHODS.find((m) => m.key === k) || {}).label || k);

export const emptyCounted = () => Object.fromEntries(CLOSING_METHODS.map((m) => [m.key, '']));

export const countedToBreakdown = (counted) =>
  Object.fromEntries(CLOSING_METHODS.map((m) => [m.key, parseFloat(counted?.[m.key]) || 0]));

// Linhas exibidas: as fixas + as demais só quando houver valor em algum dos mapas (esperado/contado)
export const visibleMethods = (...maps) =>
  CLOSING_METHODS.filter((m) => m.always || maps.some((mp) => Math.abs(Number((mp || {})[m.key]) || 0) > 0.005));
